import { Component, EventEmitter, Inject, Input, Output, TemplateRef } from '@angular/core';
import { Direction } from '@angular/cdk/bidi';
import { filter } from 'rxjs/operators';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { L10nService } from '@nano/core/l10n';

@UntilDestroy()
@Component({
  selector: 'app-collapse',
  styleUrls: ['./collapse.component.less'],
  templateUrl: './collapse.component.html',
  standalone: false
})
export class CollapseComponent {
  @Input() headerKey: string;
  @Input() headerTemplate?: TemplateRef<void>;
  @Input() active = true;
  @Output() activeChange = new EventEmitter<boolean>();

  direction: Direction;

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private l10nService: L10nService
  ) {
    this.l10nService.schema$
      .pipe(
        untilDestroyed(this),
        filter((schema) => !!schema)
      )
      .subscribe((schema) => (this.direction = schema.dir));
  }

  onActiveChange(active: boolean): void {
    if (active !== this.active) {
      this.activeChange.emit(active);
    }
  }
}
